// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrintDocsPage_title__Psa5t {
  color: rgb(151, 1, 14);
  font-family: "Ysabeau SC", sans-serif;
  font-size: 1.8rem;
  margin: 1rem 0 2rem;
  text-align: center;
}

.PrintDocsPage_contentWrapper__wMS6E {
  max-width: 800px;
  margin: 0 auto;
  padding: 1rem;
}

.PrintDocsPage_printForm__VPHtj {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  padding: 1.5rem;
  margin: 0 auto;
}

.PrintDocsPage_formSection__vHcQd {
  margin-bottom: 1.5rem;
}

.PrintDocsPage_label__1sNCa {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
  font-size: 0.95rem;
}

.PrintDocsPage_input__ktjvL,
.PrintDocsPage_select__jBHA\\+ {
  width: 100%;
  padding: 0.7rem;
  border: 2px solid #e0e0e0;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.2s ease-in-out;
  background-color: white;
}

.PrintDocsPage_input__ktjvL:focus,
.PrintDocsPage_select__jBHA\\+:focus {
  border-color: rgb(151, 1, 14);
  outline: none;
}

.PrintDocsPage_printButton__yEiYP {
  width: 100%;
  padding: 0.9rem;
  background-color: rgb(151, 1, 14);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin-top: 1rem;
}

.PrintDocsPage_printButton__yEiYP:hover:not(:disabled) {
  background-color: rgb(121, 1, 11);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.PrintDocsPage_printButton__yEiYP:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.PrintDocsPage_error__JDPKa {
  color: #ff4444;
  margin: 1rem 0;
  padding: 1rem;
  background-color: #ffe5e5;
  border-radius: 4px;
  text-align: center;
  font-size: 0.9rem;
}

.PrintDocsPage_searchContainer__-ZQb9 {
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;
}

.PrintDocsPage_searchResults__mUVdo {
  position: absolute;
  z-index: 1000;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  top: 100%;
  margin-top: 0.3rem;
}

.PrintDocsPage_searchResultItem__Qql8b {
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 0.9rem;
}

.PrintDocsPage_searchResultItem__Qql8b:hover {
  background-color: #f5f5f5;
}

.PrintDocsPage_searchLoading__Ut6ox {
  padding: 10px;
  color: #666;
  font-style: italic;
  font-size: 0.9rem;
}

.PrintDocsPage_selectedUser__hEG9h {
  padding: 0.8rem;
  background: #f8f8f8;
  border-radius: 4px;
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #333;
}

@media (max-width: 768px) {
  .PrintDocsPage_contentWrapper__wMS6E {
    padding: 0.5rem;
  }

  .PrintDocsPage_title__Psa5t {
    font-size: 1.4rem;
    margin: 0.5rem 0 1.5rem;
  }

  .PrintDocsPage_printForm__VPHtj {
    padding: 1rem;
  }

  .PrintDocsPage_printButton__yEiYP {
    padding: 0.8rem;
    font-size: 0.95rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AdminPage/PrintDocsPage/PrintDocsPage.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;;EAEE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".title {\r\n  color: rgb(151, 1, 14);\r\n  font-family: \"Ysabeau SC\", sans-serif;\r\n  font-size: 1.8rem;\r\n  margin: 1rem 0 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.contentWrapper {\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n  padding: 1rem;\r\n}\r\n\r\n.printForm {\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid #e0e0e0;\r\n  padding: 1.5rem;\r\n  margin: 0 auto;\r\n}\r\n\r\n.formSection {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.label {\r\n  display: block;\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 500;\r\n  color: #333;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.input,\r\n.select {\r\n  width: 100%;\r\n  padding: 0.7rem;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  transition: border-color 0.2s ease-in-out;\r\n  background-color: white;\r\n}\r\n\r\n.input:focus,\r\n.select:focus {\r\n  border-color: rgb(151, 1, 14);\r\n  outline: none;\r\n}\r\n\r\n.printButton {\r\n  width: 100%;\r\n  padding: 0.9rem;\r\n  background-color: rgb(151, 1, 14);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease-in-out;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.printButton:hover:not(:disabled) {\r\n  background-color: rgb(121, 1, 11);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.printButton:disabled {\r\n  background-color: #cccccc;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.error {\r\n  color: #ff4444;\r\n  margin: 1rem 0;\r\n  padding: 1rem;\r\n  background-color: #ffe5e5;\r\n  border-radius: 4px;\r\n  text-align: center;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.searchContainer {\r\n  position: relative;\r\n  width: 100%;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.searchResults {\r\n  position: absolute;\r\n  z-index: 1000;\r\n  width: 100%;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  background: white;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  top: 100%;\r\n  margin-top: 0.3rem;\r\n}\r\n\r\n.searchResultItem {\r\n  padding: 10px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.searchResultItem:hover {\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.searchLoading {\r\n  padding: 10px;\r\n  color: #666;\r\n  font-style: italic;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.selectedUser {\r\n  padding: 0.8rem;\r\n  background: #f8f8f8;\r\n  border-radius: 4px;\r\n  margin-top: 0.5rem;\r\n  font-size: 0.9rem;\r\n  color: #333;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .contentWrapper {\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  .title {\r\n    font-size: 1.4rem;\r\n    margin: 0.5rem 0 1.5rem;\r\n  }\r\n\r\n  .printForm {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .printButton {\r\n    padding: 0.8rem;\r\n    font-size: 0.95rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `PrintDocsPage_title__Psa5t`,
	"contentWrapper": `PrintDocsPage_contentWrapper__wMS6E`,
	"printForm": `PrintDocsPage_printForm__VPHtj`,
	"formSection": `PrintDocsPage_formSection__vHcQd`,
	"label": `PrintDocsPage_label__1sNCa`,
	"input": `PrintDocsPage_input__ktjvL`,
	"select": `PrintDocsPage_select__jBHA+`,
	"printButton": `PrintDocsPage_printButton__yEiYP`,
	"error": `PrintDocsPage_error__JDPKa`,
	"searchContainer": `PrintDocsPage_searchContainer__-ZQb9`,
	"searchResults": `PrintDocsPage_searchResults__mUVdo`,
	"searchResultItem": `PrintDocsPage_searchResultItem__Qql8b`,
	"searchLoading": `PrintDocsPage_searchLoading__Ut6ox`,
	"selectedUser": `PrintDocsPage_selectedUser__hEG9h`
};
export default ___CSS_LOADER_EXPORT___;
